export type LocationType = {
  hostname: string;
};

export const getHostname = (location?: LocationType): string => {
  const hostname = location ? location.hostname : window?.location?.hostname;

  return hostname || '';
};
